import {cloneDeep} from 'lodash'
import {ModuleFc} from '@/project'
import {removeItem, updateAll, updateObject} from '@/store/utils'
import {FooterState} from './types'

const whiteList: Array<keyof FooterState> = ['active', 'label', 'height']

const initState: FooterState = {
  height: 80,
  label: null,
  buttons: [],
  active: false,
}

const module: ModuleFc<FooterState> = () => {
  return {
    namespaced: true,
    state: cloneDeep(initState),
    mutations: {
      update(state, payload) {
        updateObject(state, payload, whiteList)
      },
      addButton(state, payload) {
        updateAll(state.buttons, payload)
      },
      removeButton(state, id: string) {
        removeItem(state.buttons, {id})
      },
      clear(state) {
        updateObject(state, initState)
      },
      active(state, payload: boolean) {
        state.active = payload
      },
    },
  }
}

export default module
